(function () {

    'use strict';

    angular
        .module('AutoPrequal')
        .factory('DataFactory', DataFactory);

    DataFactory.$inject = ['$rootScope', '$q', 'SessionFactory'];

    function DataFactory($rootScope, $q, SessionFactory) {

        function setData(data) {
            if ($rootScope.validatingAllSteps) return;
            $.extend(true, dataFactory.appData.applicant, data);
            if (env == "DEV") {
                console.log(dataFactory.appData, data);
            }
            var deferred = $q.defer();
            SessionFactory.updateCurrentSession(dataFactory.appData.applicant)
                .then(function (response) {
                    deferred.resolve(response)
                })
            return deferred.promise;
        };

        var dataFactory = {

            setData: setData,
            appData: {
                "application": {

                },
                "applicant": {
                    "appState": {
                        "welcome": false,
                        "applicantName": false,
						"applicantContact": false,
						"applicantAddress": false,
                        "birthdayMonth": false,
                        "birthdayDay": false,
						"birthdayYear": false,
						"applicantIncome": false,
						"applicantMortgage": false,
                        "reviewTerms": false,
                        "tradein": false,
						"tradeinHelp": false,
						"tradeinDetails": false,
						"tradeinEstimate": false,
						"tradeinPayments": false,
						"downPayment": false,
                        "results": false
                    }
                },
                "content": {

                },
                "state": {

                },
                "submit": {

                }
            }
        };

        return dataFactory;
    };

})();
